// SPDX-FileCopyrightText: NOI Techpark <digital@noi.bz.it>
//
// SPDX-License-Identifier: AGPL-3.0-or-later

const toastPresets = {
  errorMessage: {
    autoHideDelay: 5000,
    variant: "danger",
    toaster: "b-toaster-bottom-center",
    noCloseButton: true,
  },
  successMessage: {
    autoHideDelay: 5000,
    variant: "success",
    toaster: "b-toaster-bottom-center",
    noCloseButton: true,
  }
};

export default toastPresets;